import React from 'react';

import Icon from '-!svg-react-loader?name=Instagram!../../../images/icons/instagram.svg';

const Instagram = () => {
	return <Icon />;
};

export default Instagram;
